import { GET_MUNICIPALITIES, ERROR_MUNICIPALITIES } from "./types";
import { firebase } from "../../firebase";

export const getMunicipalities = (idDepartament) => async (dispatch) => {
  try {
    let db = firebase.firestore();
    let municipalities = [];
    await db
      .collection("deliveryZones")
      .doc("honduras")
      .collection("states")
      .doc(idDepartament)
      .collection("municipalities")
      .get()
      .then((querySnapshot1) => {
        querySnapshot1.docs.map((doc) => {
          const { name } = doc.data();
          return municipalities.push({
            id: doc.id,
            text: name,
            value: JSON.stringify({ id: doc.id, ...doc.data() }),
          });
        });
      });

    dispatch({
      type: GET_MUNICIPALITIES,
      payload: municipalities,
    });
  } catch (error) {
    dispatch({
      type: ERROR_MUNICIPALITIES,
      payload: error.message,
    });
  }
};
